export const colors = {
    white: "#FFF",
    darkPink: "#e4306e",
    coolBlue: "#3199d6",
    slateBlue: "#335e90",
    lightGrey: "#fbfbfb",
    blackGrey: '#666666',
    black: "#2c2c2c",
    dullGrey: "#d7d7d7",
    darkGrey: "#9197ab",
    fuschiaPink: "#ff316d",
    darkerGrey: "#808080",
    lightBlackishGrey: "#4a4a4a",
    blackishGrey: "#4d4d4d",
    red: "#ff0000"
}
